<template>
    <div class="header clearfix">
        <p class="fl">欢迎进入酷聊官网</p>
        <p class="fr"><span class="language Chinese">简</span> / <span class="language" @click="languageChange">EN</span></p>
    </div>
</template>
<script>
export default {
    data() {
        return {
        };
    },
    components: {
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        languageChange(){
            this.$message({
                message: "正在开发中！",
                type: "info"
            });
        }
    }
};
</script>
<style scoped>
.header {
    padding: 0 110px;
    width: 100%;
    height: 24px;
    line-height: 24px;
	background-color: #f7f7fa;
    font-size: 12px!important;
    color: #323233;
    box-sizing: border-box;
}
.header p,.header span{
    cursor: pointer;
}
.language{
    padding: 0 3px;
    color: #969699;
}
.Chinese{
   color: #323233;
}
</style>
